
import Vue from 'vue';
import Router from 'vue-router';
import axios from '@/axios';
Vue.use (
  Router  
);

// Role ids as they come from the API (users.rol_id).
export const ROLE_ADMIN   = 1;
export const ROLE_CONTACT = 2;

// Shorthand for routes only an administrator may open. Every route carrying
// it is enforced by the global guard at the bottom of this file, so a contact
// cannot reach one just by typing its URL.
const adminOnly = { roles: [ROLE_ADMIN] };

export const router = new Router
(
  {
    mode: 'history',
    linkActiveClass: 'nav-item active',
    routes:
    [
      { 
        path: '/login', 
        component: () => import('@/pages/auth/Login.vue')
      },
      { 
        path: '/recovery', 
        component: () => import('@/pages/auth/Login.vue')
      },
      {
        path: '/',
        redirect: '/admin'
      },
      {
        path: '/admin',
        beforeEnter: auth,
        component: () => import('@/layout/DashboardLayout.vue'),
        children:
        [
          {
            path : "/",
            component: () => import('@/pages/HomePage.vue')
          },
          // {
          //   path: 'mediaciones',
          //   component: () => import('@/pages/mediations/MediationList.vue')
          // },
          {
            path: 'user',
            meta: adminOnly,
            component: () => import('@/pages/users/UserSingle.vue'),
            props: true,
            children:
            [
              {
                path: ':id',
                component: () => import('@/pages/users/UserSingle.vue'),
                props: true
              }
            ]
          },
          {
            path: 'tags',
            meta: adminOnly,
            component: () => import('@/pages/tags/TagsList.vue')
          },
          {
            path: 'users',
            meta: adminOnly,
            component: () => import('@/pages/users/UserList.vue')
          },
          // {
          //   path: 'solicitudes',
          //   component: () => import('@/pages/mediations/SolicitudList.vue')
          // },
          {
            path: 'solicitudes_pdte',
            meta: adminOnly,
            component: () => import('@/pages/documents/RequestDocumentationList.vue')
          },
          {
            path: 'contacts',
            meta: adminOnly,
            component: () => import('@/pages/contacts/ContactsList.vue')
          },
          {
            path: 'contact',
            meta: adminOnly,
            component: () => import('@/pages/contacts/ContactDetail.vue'),
            props: true,
            children:
            [
              {
                path: ':id',
                component: () => import('@/pages/contacts/ContactDetail.vue'),
                props : true,
              }
            ]     
          },      
          {
            path: 'solicitud_doc',
            meta: adminOnly,
            component: () => import('@/pages/documents/RequestDocumentation.vue'),
          },
          {
            path: 'plantilla_solicitud',
            meta: adminOnly,
            component: () => import('@/pages/documents/RequestDocumentationTemplate.vue'),
            props : true,
            children : [
              {
                path: ':id',
                component: () => import('@/pages/documents/RequestDocumentationTemplate.vue'),
                props : true,
              }
            ]  
          },
          {
            path: 'solicitud/:id',
            meta: adminOnly,
            component: () => import('@/pages/mediations/Solicitud.vue'),
            props : true
          },
          {
            path : 'procesar-solicitud/:id',
            meta: adminOnly,
            component: () => import('@/pages/mediations/ProcesarSolicitud.vue'),
            props : true
          },
          {
            path : 'mediation/:mediation_id',
            meta: adminOnly,
            component: () => import('@/pages/mediations/ProcesarSolicitud.vue'),
            props : true
          },
          {
            path: 'documents',
            meta: adminOnly,
            component: () => import('@/pages/documents/documentsList.vue'),
            props: true,
            children:
            [
              {
                path: ':id',
                component: () => import('@/pages/documents/documentsList.vue'),
                props: true
              }
            ]
          },   
          {
            path: 'carpetas',
            component: () => import('@/pages/documents/clientsDocuments.vue'),
            props: true,
            children:
            [
              {
                path: ':id',
                component: () => import('@/pages/documents/clientsDocuments.vue'),
                props: true
              } 
            ]
          },   
          {
            path: 'documentos',
            component: () => import('@/pages/documents/ClientDocumentsList.vue')
          },
          {
            path: 'documents_statistics',
            meta: adminOnly,
            component: () => import('@/pages/documents/statistics.vue')
          },   
          {
            path: 'ficha_cliente',
            component: () => import('@/pages/clients/clientDetail.vue')
          },
          {
            path: 'agenda',
            component: () => import('@/components/AgendaView.vue')
          }/*,
          {
            path: 'ranking_ac',
            component: () => import('@/pages/ranking/RankingAC.vue'),
          },   
          {
            path: 'admin_concursal/:id',
            component: () => import('@/pages/ranking/adminConcursal.vue'),
            props : true,
          },   
          {
            path: 'info_concurso/:id',
            component: () => import('@/pages/ranking/infoConcurso.vue'),
            props : true,
          },   
          {
            path: 'admin_concursal',
            component: () => import('@/pages/ranking/adminConcursalList.vue'),         
          }, 
          {
            path: 'concurso/:admin_id',
            component: () => import('@/pages/ranking/concursoSingle.vue'),  
            props : true,                  
          }, 
          {
            path: 'edit-concurso/:id',
            component: () => import('@/pages/ranking/concursoSingle.vue'),
            props : true,
          },
          {
            path: 'administrador',
            component: () => import('@/pages/ranking/adminConcursalSingle.vue'),
            props : true,
            children : [
              {
                path: ':id',
                component: () => import('@/pages/ranking/adminConcursalSingle.vue'),
                props : true,
              }
            ]
          }*/
        ]
      },
      { 
        path: '*', 
        component: () => import('@/pages/NotFoundPage.vue')
      }
    ]
  }
);

function auth (to, from, next)
{
  let vuex = JSON.parse (localStorage.getItem ('vuex'));
  if (vuex)
  {
    axios.get ('auth/check')
		.then (res =>
    {
			if (res.data.data.token === vuex.login.token)
            {
              if (localStorage.getItem ('path') != null){
                const pathId = localStorage.getItem ('path');
                console.log(localStorage.getItem ('path'));
                localStorage.removeItem ('path');
                next('/admin/documents?path='+pathId)
              }else{
                next()
              }
			}
			else
      {
				if (localStorage.getItem ('vuex'))
        {
					localStorage.removeItem ('vuex');
					location.reload ();
				}
				next ('/login');
			}
		})
		.catch (() =>
    {
			if (localStorage.getItem ('vuex'))
      {
				localStorage.removeItem ('vuex');
				location.reload ();
			}
      next ('/login');
    })
  }
  else
  {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var path = url.searchParams.get("path");
    console.log(path);
    if (path != null) localStorage.setItem ('path', path);
    //console.log(this.$route.query.path);
    next ('/login');
  }
}

// function admin(to, from, next) {
//   let vuex = JSON.parse(localStorage.getItem('vuex'));
//   if(vuex)
//     vuex.login.user.is_administrator == 0 ? next('/home') : next();
//   else
//     next('/login');
  
// }


// --- Role based access control ---------------------------------------------

// `auth` above only proves the session is valid; it says nothing about what
// the user is allowed to open. Without the check below a contact could reach
// any administration screen (contacts, users, tags, document requests...)
// simply by typing its URL, because the role is only used to decide which
// sidebar entries get rendered.

// The persisted Vuex state is the only place where the role is available
// synchronously, which is what a navigation guard needs.
function getStoredUser ()
{
  try
  {
    const vuex = JSON.parse (localStorage.getItem ('vuex'));
    return vuex && vuex.login ? vuex.login.user : null;
  }
  catch (error)
  {
    return null;
  }
}

// The innermost matched record wins, so a child route can tighten what its
// parent allows.
function getRequiredRoles (route)
{
  const restricted = route.matched.filter (record => record.meta && record.meta.roles);
  return restricted.length ? restricted[restricted.length - 1].meta.roles : null;
}

function isAdminDocumentsRoute (path)
{
  return path === '/admin/documents' || path.indexOf ('/admin/documents/') === 0;
}

// Where to send a user who may not open `to`. Contacts have their own
// explorer, so the deep link `auth` builds (/admin/documents?path=...) keeps
// working for them instead of dead-ending on the administrator page.
function fallbackRoute (to, user)
{
  if (Number (user.rol_id) === ROLE_CONTACT && isAdminDocumentsRoute (to.path))
    return { path: '/admin/carpetas', query: to.query };

  return { path: '/admin' };
}

router.beforeEach ((to, from, next) =>
{
  const roles = getRequiredRoles (to);
  if (!roles) return next ();

  const user = getStoredUser ();
  // No session yet: `auth` is the guard that sends them to /login.
  if (!user) return next ();

  if (roles.indexOf (Number (user.rol_id)) !== -1) return next ();

  return next (fallbackRoute (to, user));
});

export default router;
